import type { RouteRecordRaw, Router } from 'vue-router'

const EndowmentContractRoutes: RouteRecordRaw = {
  path: '/contract/financial/endowment',
  name: 'EndowmentModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'EndowmentMainRoute',
      component: () => import('./views/EndowmentView.vue'),
      meta: {
        title: 'financialEndowment.endowmentContract',
      },
    },
    {
      path: 'create',
      name: 'EndowmentCreateRoute',
      component: () => import('./views/EndowmentUpsertView.vue'),
      meta: {
        title: 'financialEndowment.createEndowmentContract',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:endowmentId',
      name: 'EndowmentEditRoute',
      component: () => import('./views/EndowmentUpsertView.vue'),
      meta: {
        title: 'financialEndowment.editEndowmentContract',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:endowmentId',
      name: 'ViewEndowmentRoute',
      component: () => import('./views/SingleEndowmentView.vue'),
      meta: {
        title: 'financialEndowment.ViewEndowment',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(EndowmentContractRoutes)
}
